import React, { Component } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLock, faSignInAlt, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";

import AuthService from "../services/auth.service";

const required = value => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        Ingrese el dato requerido!
      </div>
    );
  }
};

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.handleLogin = this.handleLogin.bind(this);
    this.onChangeUsername = this.onChangeUsername.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);

    this.state = {
      username: "",
      password: "",
      loading: false,
      message: "",
      showPassword: false
    };
  }

  onChangeUsername(e) {
    this.setState({
      username: e.target.value
    });
  }

  onChangePassword(e) {
    this.setState({
      password: e.target.value
    });
  }

  handleLogin(e) {
    e.preventDefault();

    this.setState({
      message: "",
      loading: true
    });

    this.form.validateAll();

    if (this.checkBtn.context._errors.length === 0) {
      AuthService.login(this.state.username, this.state.password).then(
        () => {
          window.location.href = `${process.env.PUBLIC_URL}/`;
        },
        error => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          this.setState({
            loading: false,
            message: resMessage
          });
        }
      );
    } else {
      this.setState({
        loading: false
      });
    }
  }

  render() {
    return (
      <div className="container d-flex align-items-center justify-content-center min-vh-100 py-5">
        <div className="card login-card shadow-sm border-0" style={{ maxWidth: 420, width: '100%' }}>
          <div className="card-body p-4 p-sm-5">
            <h4 className="fw-semibold mb-1 text-center">Ingresar</h4>
            <p className="text-muted text-center mb-4">Accedé a tu cuenta</p>

            <Form
              onSubmit={this.handleLogin}
              ref={c => {
                this.form = c;
              }}
            >
              <div className="mb-3">
                <label htmlFor="username" className="form-label">Email</label>
                <div className="input-group">
                  <span className="input-group-text bg-light"><FontAwesomeIcon icon={faEnvelope} /></span>
                  <Input
                    type="text"
                    className="form-control"
                    name="username"
                    value={this.state.username}
                    onChange={this.onChangeUsername}
                    validations={[required]}
                  />
                </div>
              </div>

              <div className="mb-3">
                <label htmlFor="password" className="form-label">Clave</label>
                <div className="input-group">
                  <span className="input-group-text bg-light"><FontAwesomeIcon icon={faLock} /></span>
                  <Input
                    type={this.state.showPassword ? "text" : "password"}
                    className="form-control"
                    name="password"
                    value={this.state.password}
                    onChange={this.onChangePassword}
                    validations={[required]}
                  />
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                    aria-label={this.state.showPassword ? "Ocultar clave" : "Mostrar clave"}
                  >
                    <FontAwesomeIcon icon={this.state.showPassword ? faEyeSlash : faEye} />
                  </button>
                </div>
              </div>

              {this.state.message && (
                <div className="alert alert-danger mb-3" role="alert">
                  {this.state.message}
                </div>
              )}

              <div className="text-center">
                <button
                  className="btn btn-primary btn-sm px-4"
                  disabled={this.state.loading}
                  type="submit"
                >
                  {this.state.loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Ingresando...
                    </>
                  ) : (
                    <>
                      <FontAwesomeIcon icon={faSignInAlt} className="me-2" />
                      Ingresar
                    </>
                  )}
                </button>
              </div>

              <CheckButton
                style={{ display: "none" }}
                ref={c => {
                  this.checkBtn = c;
                }}
              />
            </Form>
          </div>
        </div>
      </div>
    );
  }
}
